import axios from 'axios';
import { BEPI_API } from '../../../shared/config/bepiApiPaths';

const BASE_URL = `${BEPI_API.client}/quotations`;

export const ClientQuotationsApi = {
  getQuotations: () => axios.get(`${BASE_URL}/`),
  getQuotationDetails: (id) => axios.get(`${BASE_URL}/estimativa/${id}/`),
  createQuotation: (data) => axios.post(`${BASE_URL}/`, data),
  updateQuotation: (id, data) => axios.put(`${BASE_URL}/${id}/`, data),
  deleteQuotation: (id) => axios.delete(`${BASE_URL}/${id}/`)
};
